import { ILLGenericKeys } from './ll-generic-keys.model';

export class ILLRelationship {
 businessOperations: ILLGenericKeys;
 ndcProductCode: string[];
 businessOperationsCompanyRevisionId: number;
 selected: boolean;
}
